// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IMobileIdentificationCredentialType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
    configKey: string;
}

export class MobileIdentificationCredentialType implements IMobileIdentificationCredentialType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;
    public configKey: string;

    /**
        Returns All MobileIdentificationCredentialType
    **/
    get All(): IMobileIdentificationCredentialType {
        return this.FromId(1);
    }
    /**
        Returns Apple Wallet MobileIdentificationCredentialType
    **/
    get AppleMDL(): IMobileIdentificationCredentialType {
        return this.FromId(2);
    }
    /**
        Returns mID/Samsung Wallet MobileIdentificationCredentialType
    **/
    get IdemiaMDL(): IMobileIdentificationCredentialType {
        return this.FromId(3);
    }
    /**
        Returns Google Wallet MobileIdentificationCredentialType
    **/
    get GoogleMDL(): IMobileIdentificationCredentialType {
        return this.FromId(4);
    }
    /**
        Returns Samsung Wallet MobileIdentificationCredentialType
    **/
    get SamsungMDL(): IMobileIdentificationCredentialType {
        return this.FromId(5);
    }
    /**
        Returns AZ Wallet MobileIdentificationCredentialType
    **/
    get AzWalletMDL(): IMobileIdentificationCredentialType {
        return this.FromId(6);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'All', displayValue: 'All', description: 'All mobile credential types', sortOrder: 1, active: true, configKey: '' });
        this._dictionary.add('2', { id: 2, value: 'AppleMDL', displayValue: 'Apple Wallet', description: 'Apple Wallet', sortOrder: 2, active: true, configKey: '' });
        this._dictionary.add('3', { id: 3, value: 'IdemiaMDL', displayValue: 'mID/Samsung Wallet', description: 'mID/Samsung Wallet', sortOrder: 3, active: true, configKey: 'Idemia' });
        this._dictionary.add('4', { id: 4, value: 'GoogleMDL', displayValue: 'Google Wallet', description: 'Google Wallet', sortOrder: 4, active: true, configKey: 'Google' });
        this._dictionary.add('5', { id: 5, value: 'SamsungMDL', displayValue: 'Samsung Wallet', description: 'Samsung Wallet', sortOrder: 5, active: true, configKey: 'Samsung' });
        this._dictionary.add('6', { id: 6, value: 'AzWalletMDL', displayValue: 'AZ Wallet', description: 'AZ Wallet', sortOrder: 6, active: true, configKey: 'AZWallet' });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IMobileIdentificationCredentialType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IMobileIdentificationCredentialType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IMobileIdentificationCredentialType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IMobileIdentificationCredentialType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IMobileIdentificationCredentialType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        const get = (obj, path) => {
            if (path) {
                path = path.split('.');

                for (var i = 0, len = path.length - 1; i < len; i++) {
                    obj = obj[path[i]];
                }

                return obj[path[len]];
            }
            return obj;
        };

        const prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            const A = prime(a);
            const B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
